import { useState } from "react";

export const useModal = () => {
  const [isShown, setIsShown] = useState(false);
  const toggle = (shouldShow) => setIsShown(shouldShow);
  return {
    isShown,
    toggle,
  };
};
